module.exports = __webpack_public_path__ + "static/img/15.0262cd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/15.jpg
// module id = UP9R
// module chunks = 1